import {
  Button,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Tooltip,
} from "@mui/material";
import clsx from "clsx";
import i18n from "i18n/i18n";
import { useEffect, useState } from "react";
import { ReactComponent as MachineItemsSvg } from "assets/Svgs/MachineItems.svg";
import { ReactComponent as TagSvg } from "assets/Svgs/Tag.svg";
import { ReactComponent as InfoSvg } from "assets/Svgs/InfoSvg.svg";
import { useBoundStore } from "store/store";
import { NotificationTypeList } from "assets/types";
import StatusCard from "components/StatusCard";
import { Link } from "react-router-dom";
import MachineLargeImage from "../../assets/Svgs/no-machine.jpg";
import {
  getNotificationBorderColor,
  hasMalfunction,
} from "shared-functions/notification";
import DashboardStatistics from "components/DashboardStatistics";

import { ReactComponent as BarChart } from "assets/Svgs/MaintDashboardStat.svg";
import { kpisJSON } from "utils/kpisConfigs";
import { truncateWithEllipses } from "utils/helper";
import StateIcon from "components/StateIcon";

var _ = require("lodash");

interface SiteData {
  [siteId: string]: {
    name: string;
    nodeid: string;
    hasarea: Array<{ area: Record<string, any> }>;
  };
}

function Instandhaltung() {
  const lang: any = useBoundStore((state) => state.lang);

  const [equipmentStatus, setEquipmentStatus] = useState<any>({});
  const allEventsRaw: any = useBoundStore((state) => state.allEventsRaw);
  const getKpisData: any = useBoundStore((state) => state.getKpisData);
  const siteData: SiteData = useBoundStore((state) => state.subscribedSites);
  const [poolsToDisplay, setpoolsToDisplay] = useState<Array<any>>([]);
  const [tempSiteId, SetTempSiteId] = useState<string>("");
  const [currentSiteId, setCurrentSiteId] = useState<any>("");
  const [isSitesLoading, setIsSitesLoading] = useState<boolean>(true);
  const [factories, setFactories] = useState("" + i18n(lang).all);
  const [factoryId, setFactoryId] = useState<any>("");
  const [areas, setAreas] = useState("" + i18n(lang).all);
  const [title, setTitle] = useState<string>(i18n(lang)?.alle_machine_parks);
  const [startingFromTimestamp, setStartingFromTimestamp] = useState(0);
  const [siteNotificationTypes, setSiteNotificationTypes] = useState(null);
  const [containersToShow, setContainersToShow] = useState<Array<any>>([]);

  // state to set NotificationStatus Cards effected by Dropdowns
  const [updatedNotificationTypesCards, setUpdatedNotificationTypesCards] =
    useState(null);

  const [equipmentsCount, setEquipmentsCount] = useState(0);
  const [equipmentsCountError, setEquipmentsCountError] = useState(0);
  const [
    equipmentsPredictiveMaintenanceCounter,
    setEquipmentsPredictiveMaintenanceCounter,
  ] = useState<any>({});
  const [errorEventsCount, setErrorEventsCount] = useState(0);

  const getSingleEquipment = useBoundStore((state) => state.getSingleEquipment);

  const getObject = (model: string) => {
    let data = kpisJSON.filter(
      (kpi: any) =>
        kpi.model.toLowerCase() ===
        (model !== null ? model.toLowerCase() : model)
    );
    if (data.length) {
      let hasPTRTRATIO = data[0].kpis.filter(
        (kpi: any) => kpi.name === "ratiorejectdetectionvsproductstotal"
      );
      let hasPT = data[0].kpis.filter(
        (kpi: any) => kpi.name === "productstotal"
      );
      let hasRT = data[0].kpis.filter(
        (kpi: any) => kpi.name === "rejectdetectiontotal"
      );
      let hasDT24 = data[0].kpis.filter(
        (kpi: any) => kpi.name === "detectortests24h"
      );

      let hasSwitchingCycles = data[0].kpis.filter(
        (kpi: any) => kpi.name === "switchingcycles"
      );

      let hasRunTimeDerivedComponents = data[0].kpis.filter(
        (kpi: any) => kpi.name === "runtimedrivecomponents"
      );

      return {
        obj: data[0],
        hasPTRTRATIO: hasPTRTRATIO.length ? true : false,
        hasPT: hasPT.length ? true : false,
        hasRT: hasRT.length ? true : false,
        hasDT24: hasDT24.length ? true : false,
        hasSwitchingCycles: hasSwitchingCycles.length ? true : false,
        hasRunTimeDerivedComponents: hasRunTimeDerivedComponents.length
          ? true
          : false,
      };
    } else {
      return false;
    }
  };

  useEffect(() => {
    // Calc the KPIs
    let equipmentsCount = 0;
    let switchingcyclesTotal: any = {};
    let equipmentsCountError = 0;
    let predictiveMaintenanceCounter: any = {};

    let _equipmentStatus: any = {};

    for (const equipmentItem of getKpisData) {
      if (equipmentItem.equipment.haslivedata !== undefined) {
        const filteredEquipment = getSingleEquipment(
          equipmentItem.equipment.nodeid
        );

        // implementing currentstatus and opcuaconnectionstatus extraction
        const livedata =
          equipmentItem.equipment.haslivedata[0].equipmentlivedata;

        // Extracting only the two specific variables needed for the icon
        let opcuaconnectionstatus = 0;
        if (livedata.opcuaconnectionstatus.length > 0) {
          opcuaconnectionstatus = livedata.opcuaconnectionstatus[0]._value;
        }

        let currentstatus = 0;
        if (livedata.currentstatus.length > 0) {
          currentstatus = livedata.currentstatus[0]._value;
        }

        //const { opcuaconnectionstatus, currentstatus } = livedata;

        // Store result for the specific equipment using nodeid as the key
        _equipmentStatus[equipmentItem.equipment.nodeid] = {
          opcuaconnectionstatus: opcuaconnectionstatus
            ? opcuaconnectionstatus
            : 0, // 1 = Connected, 0 = Disconnected
          currentstatus: currentstatus ? currentstatus : 0, // ENUM 0-9
        };

        for (const equipmentLivedataItem of equipmentItem.equipment
          .haslivedata) {
          let obj = getObject(
            filteredEquipment &&
              filteredEquipment.equipment.hasequipmenttype &&
              filteredEquipment.equipment.hasequipmenttype[0].equipmenttype
                .model
          );

          const equipmentLivedata = equipmentLivedataItem.equipmentlivedata;

          if (
            equipmentLivedata.predictivemaintenancecounter !== undefined &&
            equipmentLivedata.predictivemaintenancecounter.length &&
            ((obj !== false && obj.hasSwitchingCycles) ||
              (obj !== false && obj.hasRunTimeDerivedComponents))
          ) {
            predictiveMaintenanceCounter[equipmentItem.equipment.nodeid] = {
              counter: equipmentLivedata.predictivemaintenancecounter[0]._value,
              threshold: 30000,
              upperLimit: 50000,
              objType: obj.hasRunTimeDerivedComponents
                ? i18n(lang).maintenance_progress_title1_1
                : obj.hasSwitchingCycles
                ? i18n(lang).maintenance_progress_title1
                : "",
            };
          }

          if (
            equipmentLivedata.currentstatus !== undefined &&
            equipmentLivedata.currentstatus.length
          ) {
            equipmentsCount++;
            if (equipmentLivedata.currentstatus[0]._value === 9) {
              equipmentsCountError++;
            }
          }
        }
      }
    }
    
    setEquipmentStatus(_equipmentStatus);
    setEquipmentsCount(equipmentsCount);
    setEquipmentsCountError(equipmentsCountError);
    setEquipmentsPredictiveMaintenanceCounter(predictiveMaintenanceCounter);
  }, [getKpisData]);

  useEffect(() => {
    // Count the error Events
    let errorEventsCount = 0;

    for (const equipmentItem of allEventsRaw) {
      if (equipmentItem.equipment.haseventlog != undefined) {
        for (const eventlogItem of equipmentItem.equipment.haseventlog) {
          for (const event of eventlogItem.eventlog.events) {
            if (event[2] == "error") {
              errorEventsCount++;
            }
          }
        }
      }
    }

    setErrorEventsCount(errorEventsCount);
  }, [allEventsRaw]);

  const handleFactoriesChange = (event: SelectChangeEvent<string>) => {
    setAreas("");
    const selectedValue = event.target.value;

    if (selectedValue === i18n(lang).all) {
      // Set factories to an array containing all the keys
      ExtractMachinesofAllAreasFromSAE();
    } else {
      // Set factories to an array with the selected value
      ExtractMachinesofSAE(selectedValue);
    }
    setFactories(selectedValue);
  };

  const [geratetype, setGeratetype] = useState(i18n(lang).all);
  const handleAreasChange = (event: SelectChangeEvent<string>) => {
    const selectedValue = event?.target?.value;

    if (selectedValue === i18n(lang).all && factories === i18n(lang).all) {
      // Set areasNodeIds to an array containing all the nodeids
      ExtractMachinesofAllAreasFromSAE();
    } else if (
      selectedValue === i18n(lang).all &&
      factories !== i18n(lang).all
    ) {
      ExtractMachinesofAreaFromSingleSAE(factories);
    } else {
      // Set areasNodeIds to an array with the selected value
      ExtractMachinesofAreaFromSAE(event?.target?.value);
    }
    setAreas(selectedValue);
  };

  const ExtractMachinesofSAE = (nodeId: string) => {
    // set Boolean to allow conditional UI
    let tempContainers: {
      nodeid: string;
      name: string;
      data: any[];
      key: number;
      siteName: string;
      areaName: string;
    }[] = [];

    if (Object.keys(siteData).length > 0) {
      let i = 0;
      for (const site of Object.keys(siteData)) {
        if (siteData[site].nodeid == nodeId) {
          if (siteData[site].hasarea !== undefined) {
            for (const area of siteData[site].hasarea) {
              let tempContainer: {
                nodeid: string;
                name: string;
                data: any[];
                key: number;
                siteName: string;
                areaName: string;
              } = {
                nodeid: "",
                name: "",
                data: [],
                key: i,
                siteName: siteData[site].name,
                areaName: area.area.name,
              };

              area.area?.hasequipment?.forEach(
                (equipment: { equipment?: Record<string, any> }) => {
                  const equipmentData: Record<string, any> | undefined =
                    equipment?.equipment;

                  if (equipmentData) {
                    tempContainer.data.push(equipmentData);
                    tempContainer.name = equipmentData.name;
                    tempContainer.nodeid = equipmentData.nodeid;
                  }
                }
              );

              tempContainers.push(tempContainer);
              i++;
            }
          }
        }
      }
    }
    setpoolsToDisplay(tempContainers);
  };

  const ExtractMachinesofAllAreasFromSAE = () => {
    let tempContainers: {
      nodeid: string;
      name: string;
      data: any[];
      key: number;
      siteName: string;
      areaName: string;
    }[] = [];

    if (Object.keys(siteData).length > 0) {
      let i = 0;
      for (const site of Object.keys(siteData)) {
        if (siteData[site].hasarea) {
          for (const area of siteData[site].hasarea) {
            let tempContainer: {
              nodeid: string;
              name: string;
              data: any[];
              key: number;
              siteName: string;
              areaName: string;
            } = {
              nodeid: "",
              name: "",
              data: [],
              key: i,
              siteName: siteData[site].name,
              areaName: area.area.name,
            };

            area.area?.hasequipment?.forEach(
              (equipment: { equipment?: Record<string, any> }) => {
                const equipmentData: Record<string, any> | undefined =
                  equipment?.equipment;

                if (equipmentData) {
                  tempContainer.data.push(equipmentData);
                  tempContainer.name = equipmentData.name;
                  tempContainer.nodeid = equipmentData.nodeid;
                }
              }
            );

            tempContainers.push(tempContainer);
            i++;
          }
        }
      }
    }
    setpoolsToDisplay(tempContainers);
  };

  const ExtractMachinesofAreaFromSingleSAE = (nodeId: string) => {
    // set Boolean to allow conditional UI
    let filtered_machines;

    let key = 0;

    const FilteredObjectArray = [];

    for (const site of Object.keys(siteData)) {
      if (siteData[site].nodeid == nodeId) {
        if (siteData[site].hasarea) {
          for (const area of siteData[site].hasarea) {
            let tempContainer: {
              nodeid: string;
              name: string;
              data: any[];
              key: number;
              siteName: string;
              areaName: string;
            } = {
              nodeid: "",
              name: "",
              data: [],
              key: key,
              siteName: siteData[site].name,
              areaName: area.area.name,
            };

            area.area?.hasequipment?.forEach(
              (equipment: { equipment?: Record<string, any> }) => {
                const equipmentData: Record<string, any> | undefined =
                  equipment?.equipment;
                if (equipmentData) {
                  tempContainer.data.push(equipmentData);
                  tempContainer.name = equipmentData.name;
                  tempContainer.nodeid = equipmentData.nodeid;
                }
              }
            );

            FilteredObjectArray.push(tempContainer);
            key++;
          }
        }
      }
    }

    setpoolsToDisplay(FilteredObjectArray);
  };

  const ExtractMachinesofAreaFromSAE = (nodeId: string) => {
    // set Boolean to allow conditional UI
    let filtered_machines;

    let key = 0;

    let FilteredObject: {
      nodeid: string;
      name: string;
      data: any[];
      key: number;
      siteName: string;
      areaName: string;
    } = {
      nodeid: "",
      name: "",
      data: [],
      key: key,
      siteName: "",
      areaName: "",
    };
    const FilteredObjectArray = [];
    let areaToUpdateTitle;

    for (const site of Object.keys(siteData)) {
      if (siteData[site].hasarea !== undefined) {
        for (const area of siteData[site].hasarea) {
          if (area.area.nodeid == nodeId) {
            areaToUpdateTitle = area.area;
            filtered_machines = area.area?.hasequipment;
            FilteredObject.nodeid = "";
            FilteredObject.name = "";
            FilteredObject.siteName = siteData[site].name;
            FilteredObject.areaName = area.area.name;
            setTitle(areaToUpdateTitle.name); // Move the setTitle here
          }
        }
      }
    }

    filtered_machines.map((equipment: { equipment?: Record<string, any> }) => {
      const equipmentData: Record<string, any> | undefined =
        equipment?.equipment;
      if (equipmentData) {
        FilteredObject.data.push(equipmentData);
        FilteredObject.name = equipmentData.name;
        FilteredObject.nodeid = equipmentData.nodeid;
      }
    });

    FilteredObjectArray.push(FilteredObject);

    setpoolsToDisplay(FilteredObjectArray);
  };

  const updatePoolsToDisplay = () => {
    let tempNotificationTypes: any = {};
    NotificationTypeList[0].forEach((type) => {
      tempNotificationTypes[type.value] = { count: 0, selected: false };
    });

    // set Boolean to allow conditional UI
    tempNotificationTypes.hasNotifications = false;

    let tempContainers: {
      nodeid: string;
      name: string;
      data: any[];
      key: number;
      siteName: string;
      areaName: string;
    }[] = [];

    if (Object.keys(siteData).length > 0) {
      let i = 0;
      for (const site of Object.keys(siteData)) {
        if (siteData[site].hasarea) {
          for (const area of siteData[site].hasarea) {
            let tempContainer: {
              nodeid: string;
              name: string;
              data: any[];
              key: number;
              siteName: string;
              areaName: string;
            } = {
              nodeid: "",
              name: area.area.name,
              data: [],
              key: i,
              siteName: siteData[site].name,
              areaName: area.area.name,
            };

            area.area?.hasequipment?.forEach(
              (equipment: { equipment?: any }) => {
                const equipmentData: Record<string, any> | undefined =
                  equipment?.equipment;
                tempContainer.nodeid = equipment?.equipment?.nodeid;
                if (equipmentData) {
                  tempContainer.data.push(equipmentData);
                  let equipmentAlreadyAdded = false;
                  equipmentData.hasnotification?.forEach(
                    (notification: any) => {
                      const type = String(notification.notification.type);

                      if (
                        notification.notification.status < 2 &&
                        notification.notification.created >
                          startingFromTimestamp
                      ) {
                        // the notification is within the selected time interval
                        if (equipmentAlreadyAdded === false) {
                          equipmentAlreadyAdded = true;
                        }
                        tempNotificationTypes[type].count =
                          tempNotificationTypes[type].count + 1;

                        tempNotificationTypes[type].equiipmentId =
                          equipment.equipment.nodeid;

                        tempNotificationTypes.hasNotifications = true;

                        tempNotificationTypes[type].newSinceLastCheck =
                          tempNotificationTypes[type].count;

                        tempNotificationTypes[type].type =
                          notification.notification.type;
                      }
                    }
                  );
                }
              }
            );

            tempContainers.push(tempContainer);
            i++;
          }
        }
      }
    }
    setpoolsToDisplay(tempContainers);

    setSiteNotificationTypes(tempNotificationTypes);
  };

  const updateCards = () => {
    if (factories === "Alle" && areas === "Alle") {
      setUpdatedNotificationTypesCards(null);
      return;
    }

    let tempNotificationTypes: any = {};
    NotificationTypeList[0].forEach((type) => {
      tempNotificationTypes[type.value] = { count: 0, selected: false };
    });

    // set Boolean to allow conditional UI
    tempNotificationTypes.hasNotifications = false;

    let tempContainer: {
      nodeid: string;
      name: string;
      data: any[];
      key: number;
      siteName: string;
      areaName: string;
    } = {
      nodeid: "",
      name: "",
      data: [],
      key: 0,
      siteName: "",
      areaName: "",
    };

    poolsToDisplay.length &&
      poolsToDisplay.map((container) => {
        container.data.map((equipment: any) => {
          const equipmentData: Record<string, any> | undefined = equipment;
          tempContainer.nodeid = equipment?.nodeid;
          if (equipmentData) {
            tempContainer.data.push(equipmentData);
            let equipmentAlreadyAdded = false;
            equipmentData.hasnotification?.forEach((notification: any) => {
              const type = String(notification.notification.type);

              if (
                notification.notification.status < 2 &&
                notification.notification.created > startingFromTimestamp
              ) {
                // the notification is within the selected time interval
                if (equipmentAlreadyAdded === false) {
                  equipmentAlreadyAdded = true;
                }
                tempNotificationTypes[type].count =
                  tempNotificationTypes[type].count + 1;

                tempNotificationTypes[type].equiipmentId = equipment.nodeid;

                tempNotificationTypes.hasNotifications = true;

                tempNotificationTypes[type].newSinceLastCheck =
                  tempNotificationTypes[type].count;

                tempNotificationTypes[type].type =
                  "" + notification.notification.type;
              }
            });
          }
        });
      });

    setUpdatedNotificationTypesCards(tempNotificationTypes);
  };

  // updating NotificationStatus Cards Count When Either Site or Area Changes from Dropdone
  useEffect(() => {
    updateCards();
  }, [poolsToDisplay]);

  // updating Equipment List ( handeling Side Effect Either by Select Dropdowns(updatedNotificationTypesCards) or By Clicking on NotificationSrtatus Cards)
  useEffect(() => {
    let containersTemp = _.cloneDeep(poolsToDisplay);

    // if any site or area is selected;
    let isNotNull = updatedNotificationTypesCards !== null;

    let targetObj = isNotNull
      ? updatedNotificationTypesCards
      : siteNotificationTypes;

    containersTemp?.forEach((container: any) => {
      container.data.forEach((equipment: any) => {
        let remove = true;

        let filterActive = false;
        if (targetObj) {
          Object.entries(targetObj).map((item: any) => {
            if (item[1].selected == true) {
              filterActive = true;
            }
            return item;
          });
        }

        let equipmentAlreadyAdded = false;

        equipment.hasnotification?.forEach((notification: any) => {
          if (targetObj) {
            Object.entries(targetObj).map((item: any) => {
              if (item[1].selected == true) {
                if (item[0] == String(notification.notification.type)) {
                  remove = false;
                }
              }
              return item;
            });
          }
        });

        if (filterActive && remove) {
          container.data = _.reject(container.data, function (item: any) {
            return item.nodeid === equipment.nodeid;
          });
        }
      });
    });
    setContainersToShow(containersTemp);
  }, [siteNotificationTypes, poolsToDisplay, updatedNotificationTypesCards]);

  useEffect(() => {
    // render site name and menu when data is available
    const tempSiteId = Object.keys(siteData)[0];
    SetTempSiteId(tempSiteId);
    setCurrentSiteId(Object.keys(siteData)[0]);
    setIsSitesLoading(false);

    if (Object.keys(siteData).length) {
      setTitle(siteData[tempSiteId]?.name);
      setIsSitesLoading(false);
    }
  }, [siteData]);

  useEffect(() => {
    // Update poolsToDisplay when currentSiteId changes
    updatePoolsToDisplay();
  }, [currentSiteId]);

  useEffect(() => {
    // removing cross icon from NotificationStatusCard , like refresh

    if (
      (siteNotificationTypes as any)?.hasNotifications ||
      (updatedNotificationTypesCards as any)?.hasNotifications
    ) {
      [0, 2, 6, 7].map((type) => {
        removeNotificationFilter(type);
      });
    }
  }, [factories, areas]);

  function addNotificationFilter(type: any) {
    // if any site or area is selected;
    let isNotNull = updatedNotificationTypesCards !== null;

    let didChange = false;
    let siteNotificationTypesTemp = _.cloneDeep(
      isNotNull ? updatedNotificationTypesCards : siteNotificationTypes
    );

    Object.entries(siteNotificationTypesTemp).map(
      ([key, item]: [string, any]) => {
        if (key === type && item.selected === false) {
          item.selected = true;
          didChange = true;
        }
      }
    );
    if (didChange) {
      if (isNotNull) {
        setUpdatedNotificationTypesCards(siteNotificationTypesTemp);
      } else {
        setSiteNotificationTypes(siteNotificationTypesTemp);
      }
    }
  }

  function removeNotificationFilter(type: any) {
    // if any site or area is selected;
    let isNotNull = updatedNotificationTypesCards !== null;

    let didChange = false;
    let siteNotificationTypesTemp = _.cloneDeep(
      isNotNull ? updatedNotificationTypesCards : siteNotificationTypes
    );

    Object.entries(siteNotificationTypesTemp).map(
      ([key, item]: [string, any]) => {
        if (key === type && item.selected === true) {
          item.selected = false;
          didChange = true;
        }
      }
    );
    if (didChange) {
      if (isNotNull) {
        setUpdatedNotificationTypesCards(siteNotificationTypesTemp);
      } else {
        setSiteNotificationTypes(siteNotificationTypesTemp);
      }
    }
  }

  const renderKPIs = (first: any, second: any, third: any) => {
    return (
      <>
        <div className="dashboard" style={{ marginTop: "2.5%" }}>
          <div className="header" style={{ marginTop: "50px", paddingLeft: 0 }}>
            <div className="title">{i18n(lang)?.overall_statistics}</div>
          </div>
        </div>

        <div className="mainDashboardStatsWrapper">
          <DashboardStatistics
            style={{ width: "260px", height: "156px" }}
            text={
              <div>
                <div>{i18n(lang)?.maintenance_dashboard_kpi_1_title1}</div>
                <div>{i18n(lang)?.maintenance_dashboard_kpi_1_title2}</div>
              </div>
            }
            stats={
              <div className="__stats" style={{ paddingTop: "12px" }}>
                <span
                  className="first0"
                  style={{ color: first[0] > 0 ? "#ff3d00" : "#6FA03B" }}
                >
                  {" "}
                  {first[0]}{" "}
                </span>
                <span className="first1">/ {first[1]} </span>
              </div>
            }
          />{" "}
          <DashboardStatistics
            style={{ width: "260px", height: "156px" }}
            text={
              <div>
                <div>{i18n(lang)?.maintenance_dashboard_kpi_2_title1}</div>
                <div>{i18n(lang)?.maintenance_dashboard_kpi_2_title2}</div>
              </div>
            }
            stats={
              <div
                className="__stats "
                style={{
                  color: "#000000DE",
                  display: "flex",
                  justifyContent: "center",
                  columnGap: "20px",
                  paddingTop: "12px",
                }}
              >
                <div className="versus">
                  <span className="third0"> {second[0]} </span>
                  <span className="second_vs"> {second[1]} </span>
                  <span className="second1"> {second[2]} </span>
                </div>
              </div>
            }
          />{" "}
        </div>
      </>
    );
  };

  // Calculate the number of malfunctions
  let malFunctions = 0;

  if (
    updatedNotificationTypesCards !== null ||
    siteNotificationTypes !== null
  ) {
    Object.entries(
      updatedNotificationTypesCards !== null
        ? (updatedNotificationTypesCards as any)
        : siteNotificationTypes
    ).map((item: any) => {
      let type = item[0];
      if (type === "0") {
        // for Störungrn
        malFunctions = item[1].count;
      }
    });
  }

  return (
    <Card className={clsx("initialCard", " instandhaltung")}>
      <div className="dashboard">
        <div className="header" style={{ padding: "0" }}>
          <div className="title">{i18n(lang)?.tab_dashboard}</div>
          <div style={{ display: "flex" }}>
            <div style={{ paddingRight: "24px" }}>
              <FormControl fullWidth variant="standard">
                <InputLabel id="demo-simple-select-label">
                  {i18n(lang)?.sites}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={factories}
                  sx={{ minWidth: "180px" }}
                  label={i18n(lang)?.sites}
                  onChange={handleFactoriesChange}
                >
                  <MenuItem value={i18n(lang).all} selected>
                    {i18n(lang).all}
                  </MenuItem>
                  {siteData &&
                    Object.keys(siteData).map((key: any, index) => (
                      <MenuItem value={siteData[key]?.nodeid}>
                        {siteData[key]?.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>
            <div>
              <FormControl fullWidth variant="standard">
                <InputLabel id="demo-simple-select-label">
                  {i18n(lang)?.areas}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={areas}
                  sx={{ minWidth: "180px" }}
                  label={i18n(lang)?.areas}
                  onChange={handleAreasChange}
                >
                  {factories === i18n(lang).all ? (
                    <MenuItem value={i18n(lang).all}>{i18n(lang).all}</MenuItem>
                  ) : (
                    <MenuItem value={i18n(lang).all}>{i18n(lang).all}</MenuItem>
                  )}
                  {siteData &&
                    Object.keys(siteData).map((key) => {
                      const factory = siteData[key];

                      if (
                        factories === i18n(lang).all ||
                        factories === factory.nodeid
                      ) {
                        return (
                          factory.hasarea &&
                          factory.hasarea.map((area) => (
                            <MenuItem
                              value={area?.area?.nodeid}
                              key={area?.area?.nodeid}
                            >
                              {area?.area?.name}
                            </MenuItem>
                          ))
                        );
                      }

                      return null;
                    })}
                </Select>
              </FormControl>
            </div>
          </div>
        </div>
      </div>

      {renderKPIs(
        [equipmentsCountError, equipmentsCount],
        [malFunctions],
        "99.1"
      )}

      <div className="generalHeading" style={{ padding: "36px 0px 24px 0px" }}>
        {i18n(lang)?.your_devices} (
        {containersToShow.map((c) => c.data).flat().length})
      </div>

      <div className="statusWrapper ">
        {(updatedNotificationTypesCards !== null
          ? (updatedNotificationTypesCards as any)
          : (siteNotificationTypes as any)
        )?.hasNotifications ? (
          Object.entries(
            updatedNotificationTypesCards !== null
              ? (updatedNotificationTypesCards as any)
              : siteNotificationTypes
          ).map((item: any) => {
            let type = item[0];

            if (
              item[1]?.count > 0 &&
              (item[1]?.type == "2" ||
                item[1]?.type == "6" ||
                item[1]?.type == "0" ||
                item[1]?.type == "7")
            ) {
              return (
                <div className="statusDiv bxShadow">
                  <div
                    style={{
                      backgroundColor: getNotificationBorderColor(type),
                    }}
                  ></div>
                  <StatusCard
                    key={type}
                    type={type}
                    count={item[1]?.count}
                    newSinceLastCheck={item[1].newSinceLastCheck}
                    selected={item[1].selected}
                    onPressCard={addNotificationFilter}
                    onPressXIcon={() => {
                      removeNotificationFilter(type);
                    }}
                  />
                </div>
              );
            }
          })
        ) : (
          <div>
            <span>0 {i18n(lang)?.notification_plural}</span>
          </div>
        )}
      </div>

      {containersToShow.map((itemArea, index) => {
        return itemArea.data.map((item: any, index: any) => {
          let hasMachineImage = item.image?.url ? item.image?.url : false;
          return (
            <>
              {item !== undefined && (
                <Grid item xs={6} md={6} key={index}>
                  <Link
                    to="/machine-detail"
                    state={{ machineNodeId: item.nodeid }}
                  >
                    <div className={clsx("maintenanceCardItem", " bxShadow")}>
                      <div
                        style={{
                          backgroundImage: `url(${
                            hasMachineImage
                              ? hasMachineImage
                              : MachineLargeImage
                          })`,
                          backgroundSize: hasMachineImage ? "contain" : "cover",
                          backgroundPosition: "center center",
                          flexShrink: 1,
                          width: "123px",
                          height: "119px",
                          overflow: "hidden",
                          borderTopLeftRadius: "4px",
                          borderBottomLeftRadius: "4px",
                          backgroundRepeat: "no-repeat",
                          display: "flex",
                          alignItems: "end",
                        }}
                      >
                        <StateIcon
                          opcuaconnectionstatus={
                            equipmentStatus[item.nodeid]?.opcuaconnectionstatus
                          }
                          currentstate={
                            equipmentStatus[item.nodeid]?.currentstatus
                          }
                        />
                      </div>
                      <div className="_content">
                        <div
                          style={{
                            backgroundColor:
                              hasMalfunction(
                                _.orderBy(
                                  item.hasnotification,
                                  ["notification.type"],
                                  ["asc"]
                                )
                              ) || "",
                          }}
                        ></div>
                        <div
                          className="mainContent"
                          style={{
                            margin: item.hasicontext
                              ? "20.5px 16px"
                              : "14px 16px",
                          }}
                        >
                          <div style={{ paddingTop: "2%" }}>
                            <div className="_title">
                              <div className="_titleText">
                                {" "}
                                <Tooltip title={item.name}>
                                  <div>
                                    {truncateWithEllipses(" " + item.name, 50)}{" "}
                                  </div>
                                </Tooltip>{" "}
                              </div>
                            </div>
                            {item.hasicontext && (
                              <div className="_status">
                                <InfoSvg /> **Störung
                              </div>
                            )}
                            <div className="_stats" style={{ display: "flex" }}>
                              <div
                                className="_iconWithText"
                                style={{
                                  paddingTop: item.hasicontext ? "4px" : "12px",
                                }}
                              >
                                {itemArea.siteName}
                              </div>
                              <div
                                className="_iconWithText"
                                style={{
                                  paddingTop: item.hasicontext ? "4px" : "12px",
                                }}
                              >
                                {itemArea.areaName}
                              </div>
                            </div>
                            <div className="_stats" style={{ display: "flex" }}>
                              <div
                                className="_iconWithText"
                                style={{
                                  paddingTop: item.hasicontext ? "4px" : "12px",
                                }}
                              >
                                {i18n(lang).inv_id} :
                                <Tooltip title={item.manufacturerserialnumber}>
                                  <div>
                                    {truncateWithEllipses(
                                      " " + item.manufacturerserialnumber,
                                      30
                                    )}{" "}
                                  </div>
                                </Tooltip>
                              </div>
                              <div
                                className="_iconWithText"
                                style={{
                                  paddingTop: item.hasicontext ? "4px" : "12px",
                                }}
                              >
                                {i18n(lang).device_serial_number + " "}

                                <Tooltip title={item.manufacturerserialnumber}>
                                  <div>
                                    {truncateWithEllipses(
                                      " " + item.manufacturerserialnumber,
                                      30
                                    )}{" "}
                                  </div>
                                </Tooltip>
                              </div>
                            </div>
                          </div>

                          {equipmentsPredictiveMaintenanceCounter[
                            item.nodeid
                          ] !== undefined ? (
                            <div className="maintItemCardStats">
                              <DashboardStatistics
                                noBoxShadow
                                style={{ width: "136px", height: "85px" }}
                                text={
                                  <div>
                                    <div className="progress_title1 truncate ">
                                      {
                                        equipmentsPredictiveMaintenanceCounter[
                                          item.nodeid
                                        ].objType
                                      }
                                    </div>
                                    <div className="progress_title2 truncate ">
                                      {i18n(lang).maintenance_progress_title2}
                                    </div>
                                  </div>
                                }
                                stats={
                                  equipmentsPredictiveMaintenanceCounter[
                                    item.nodeid
                                  ] !== undefined ? (
                                    <div
                                      style={{
                                        paddingTop: "0px",
                                        height: "auto",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "baseline",
                                        }}
                                      >
                                        <div
                                          className="progress0"
                                          style={{
                                            color:
                                              equipmentsPredictiveMaintenanceCounter[
                                                item.nodeid
                                              ].counter >
                                              equipmentsPredictiveMaintenanceCounter[
                                                item.nodeid
                                              ].threshold
                                                ? "#ff3d00"
                                                : "#6FA03B",
                                          }}
                                        >
                                          {
                                            equipmentsPredictiveMaintenanceCounter[
                                              item.nodeid
                                            ].counter
                                          }
                                        </div>
                                        <div className="progress1">
                                          /{" "}
                                          {
                                            equipmentsPredictiveMaintenanceCounter[
                                              item.nodeid
                                            ].threshold
                                          }{" "}
                                          vs.{" "}
                                          {
                                            equipmentsPredictiveMaintenanceCounter[
                                              item.nodeid
                                            ].upperLimit
                                          }
                                        </div>
                                      </div>
                                      <div className="progress">
                                        <div
                                          className="fill"
                                          style={{
                                            width:
                                              (equipmentsPredictiveMaintenanceCounter[
                                                item.nodeid
                                              ].counter /
                                                equipmentsPredictiveMaintenanceCounter[
                                                  item.nodeid
                                                ].upperLimit) *
                                                100 +
                                              "%",
                                            backgroundColor:
                                              equipmentsPredictiveMaintenanceCounter[
                                                item.nodeid
                                              ].counter >
                                              equipmentsPredictiveMaintenanceCounter[
                                                item.nodeid
                                              ].threshold
                                                ? "#ff3d00"
                                                : "#6FA03B",
                                          }}
                                        ></div>
                                        <div
                                          className="divider"
                                          style={{
                                            left:
                                              (equipmentsPredictiveMaintenanceCounter[
                                                item.nodeid
                                              ].threshold /
                                                equipmentsPredictiveMaintenanceCounter[
                                                  item.nodeid
                                                ].upperLimit) *
                                                100 +
                                              "%",
                                            color: "white",
                                          }}
                                        >
                                          |
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <div></div>
                                  )
                                }
                              />
                            </div>
                          ) : (
                            <div></div>
                          )}
                        </div>
                      </div>
                    </div>
                  </Link>
                </Grid>
              )}
            </>
          );
        });
      })}

      <Button
        variant="outlined"
        sx={{ marginBottom: 2 }}
        className="btnExtStyle"
      >
        {i18n(lang)?.more_stores}
      </Button>
    </Card>
  );
}

export default Instandhaltung;
